import React from 'react'

import '../css/all.css';
export default function Home() {
    return (
        <>
        <div className=" main container-fluid ">
           
        </div>
         
        </>
    )
}
